import { Injectable } from "@angular/core";
import { FormGroup, ValidatorFn, Validators } from "@angular/forms";

@Injectable()
export class CommonService {

  setFormPreference(form:FormGroup, fields:any[]){
    fields.forEach((field) => {
      if (field.hidden) form.removeControl(field.fieldName);
      if (field.required)
        this.addValidation(form, field.fieldName, [Validators.required]);
    });
  }

  addValidation(form: FormGroup, controlName: string, validations: ValidatorFn[]) {
    const control = form.get(controlName);
    if (control) {
      control.setValidators(validations); // Set the new validators
      control.updateValueAndValidity(); // Refresh the validation state
    }
  }

  getFormValue(form :FormGroup, fieldName:string){
    if(form.contains(fieldName))
        return form.get(fieldName).value;
  }    

  recursiveForEach(array: any[], callback: (item: any) => void): void {
    array.forEach(item => {
        callback(item);
        if (Array.isArray(item)) {
        this.recursiveForEach(item, callback);
        }
        else if (Array.isArray(item.children)){
        this.recursiveForEach(item.children, callback);
        }
    });
  } 

  coalesce<T>(value: T | null | undefined, defaultValue: T): T {
      return value != null ? value : defaultValue;
  }
}
